<template>
    <div class="box">
        <div class="logo">
            <img src="@/assets/logo.png" alt="易成数学"/>
        </div>
        <a-form class="form" @submit="login">

            <a-form-item>
                <a-input placeholder="账号" v-model="form.username">
                    <a-icon type="mobile" slot="prefix"></a-icon>
                </a-input>
            </a-form-item>
            <a-form-item>
                <a-input type="password" placeholder="密码" v-model="form.password">
                    <a-icon type="lock" slot="prefix"></a-icon>
                </a-input>
            </a-form-item>
            <a-button html-type="submit" type="primary" block>登录</a-button>
        </a-form>
        <div class="beian">
            <a href="https://beian.miit.gov.cn" target="_blank">蜀ICP备19034333号-1</a>
        </div>
    </div>
</template>


<script>
  import {mapMutations} from "vuex";

  export default {
    data() {
      return {
        form: {
          username: "",
          password: ""
        }
      };
    },
    methods: {
      login(e) {
        e.preventDefault();
        const {changeState} = this;
        this.$axios
          .post("/api/admin/login", {
            data: this.form
          })
          .then((res) => {
            if (res.code != 200) {
              this.$message.error(res.msg);
            } else {
              localStorage.setItem('token', res.data.admin_token);
              localStorage.setItem('userinfo', JSON.stringify(res.data.admin));
              //更新全局用户信息
              changeState({
                name: "userinfo",
                value: res.data.admin,
              });
              this.$router.push("/");
            }
          })
          .catch((err) => {
            console.error(err);
          });

      },
      ...mapMutations(["changeState"])
    }
  };
</script>

<style lang="less" scoped>
    .box {
        width: 20rem;
        margin: 8rem auto;

        .logo {
            width: 10rem;
            margin: 0 auto;

            img {
                max-width: 100%;
            }
        }

        .form {
            margin-top: 2rem;
        }
    }

    .beian {
        position: fixed;
        bottom: 20px;
        left: 0;
        right: 0;
        text-align: center;

        a {
            color: #666;
            text-decoration: none;
            font-size: 12px;

            &:hover {
                color: #1890ff;
            }
        }
    }
</style>